export default {
  // 濮阳县
  410928000: {
    url: "http://gis-server.chiaic.com/iserver/services/map-ZuoYangXianTeXiaoDiTu/rest/maps/濮阳县L11-L14_GD_TX",
    center: [115.12, 35.59],
    zoom: 11,
    weatherCode: '101181301',
    geoJSON: require("@/assets/JSON/geoJSON/410928000.json")
  },
};
